import { useState } from 'react';
import Calendar from '../../components/calendar/Calendar';
import { SessionModal } from '../instructor/InstructorCalendar';

export default function SharedCalendars({ instructors, loading, error, onRetry }) {
  const [selectedId, setSelectedId] = useState('');
  const [selectedSession, setSelectedSession] = useState(null);
  const instructor = instructors.find(i => i.id === selectedId) || instructors[0];

  return (
    <div className="page">
      <div className="page-header">
        <h1 className="page-title">SHARED CALENDAR</h1>
        <p className="page-subtitle">View all sessions, including pending and confirmed bookings. This calendar is read only.</p>
      </div>
      {loading ? <p>Loading shared calendars...</p> : error ? (
        <div role="alert">{error} <button className="btn btn-outline btn-sm" onClick={onRetry}>Retry</button></div>
      ) : !instructor ? <p>No trainer calendars have been shared with your account.</p> : (
        <>
          {instructors.length > 1 ? (
            <label className="form-group">Trainer
              <select className="form-input" value={instructor.id} onChange={e => { setSelectedId(e.target.value); setSelectedSession(null); }}>
                {instructors.map(i => <option key={i.id} value={i.id}>{i.first_name} {i.last_name}</option>)}
              </select>
            </label>
          ) : <h2>{instructor.first_name} {instructor.last_name}’s Schedule</h2>}
          <Calendar key={instructor.id} apiEndpoint={`/api/parent/shared-calendars/${instructor.id}`} onSessionClick={setSelectedSession} role="instructor" />
          {selectedSession && <SessionModal session={selectedSession} onClose={() => setSelectedSession(null)} />}
        </>
      )}
    </div>
  );
}
